/**
 * modal.remove
 * Display a modal based on a provided data attribute set to remove something
 *
 * @package Monapix
 * @version 3.0.1
 * @author Binary Cats Inc.
 */

$(function()
{
    "use strict";

    /**
     * Attach the behaviour to the #remove modal
     */
    $('#remove').on('show.bs.modal', function (event){
        // Button that triggered the modal
        var button  = $(event.relatedTarget)
        // Update the modal's content.
        var modal = $(this)
        // Extract info from data-* attributes
        var route = button.data('route');
        var title = button.data('title') || 'Please Confirm';
        var titleClass = button.data('title-class') || '';
        var message = button.data('message') || 'this record';
        var return_url = button.data('return-url') || '';

        // set the action on the form
        modal.find('form').attr('action', route)
        modal.find('input[name="return_url"]').val(return_url)
        modal.find('#remove-title').text(title)
        modal.find('#remove-message').text(message)
    });
});



// WEBPACK FOOTER //
// ./resources/js/services/jquery/modal.remove.js